"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _path, _path2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (prefix = '') => {
  return [_path || (_path = _react.default.createElement("path", {
    d: "M11.004 14.134h2v-6h-2v6zm1 1.5a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5z"
  })), _path2 || (_path2 = _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.115 20.418l10-19h1.77l10 19L22 21.884H2l-.885-1.466zm2.542-.534h16.687L12 4.03 3.657 19.884z"
  }))];
};

exports.default = _default;